import styled from 'styled-components';

export const Container = styled.span`
    
`;

export const Text = styled.span`
    cursor: pointer;
`;

export const Popup = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: ${p => p.theme.c.blackShadow35};
    z-index: 101;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Wrapper = styled.div`
    padding: 32px;
    background-color: white;
    svg {
        display: block;
    }
`;